import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { ProductViewModalComponent } from '../product/product-view-modal/product-view-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';



@Component({
  selector: 'app-available-networklocations',
  templateUrl: './available-networklocations.component.html',
  styleUrls: ['./available-networklocations.component.scss']
})
export class AvailableNetworklocationsComponent implements OnInit {
  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  AvailableProducts: any[];
  selectedProducts: any[] = [];
  mappedProducts: any[] = [];
  screenheading :any= "";
  selectedProductsNet: any[] = [];
  constructor(
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    public commonService: CommonService
  ) { }

  ngOnInit() {
    debugger;
    this.screenheading = "Available Network Locations";
    this.getNetworkLocations();
    this.selectedProducts = this.Content.content.mappedIds;
   
  }

  checkSelected(){
    this.AvailableProducts.forEach((item:any) => {
      if(this.selectedProducts.findIndex(x=> x == item.Value) != -1) {
        item.isSelected = true;
      }
      else {
        item.isSelected = false;
        
      }     
      
  })
  }

  // getSavedappings() {
  //   this.summaryService.getRecord('api/Product/getSavedMappings?RecordID=' + this.Content.content.id).subscribe((summary : any) => {
  //     //debugger;
  //     if(summary.length > 0){
  //       this.selectedProducts = summary;
  //     }
  //     this.checkSelected();
  //   });
  // }

  getSelectdOrNot(item) {
    // if (this.selectedProducts.indexOf(item) != -1) {
    //   return true;
    // }
    // else {
    //   return true;
    // }
  }
  SaveMapping() {
   
    var selectedValues = "";
    if (this.selectedProducts != undefined && this.selectedProducts.length > 0) {
      this.selectedProducts.forEach(obj => {
        var Mapobj = this.AvailableProducts.filter(function (element) 
        {
          return element.Value ==obj;
        })[0];
        if (Mapobj != null && Mapobj != undefined) {
          this.mappedProducts.push(Mapobj);
        }
          
      });

      // this.selectedProductsNet.forEach(obj => {
        
      //   var Mapobj = this.AvailableProducts.filter(function (element) 
      //   {
      //     return element.Value ==obj;
      //   })[0];
      //   if (Mapobj != null && Mapobj != undefined) {
      //     this.mappedProducts.push(Mapobj);
      //   }
          
      // });

   
      var data = new FormData();
      data["TransactionID"] = this.Content.content.id;
      data["clsificationType"] = selectedValues;
      //this.action.next(this.mappedProducts);
      this.modalRef.close(this.mappedProducts);
      /* this.summaryService.Insert('api/Product/SaveMappedNetworks', { "TransactionID": this.Content.content.id, "clsificationType": selectedValues}).subscribe(summary => {
        
        this.modalRef.hide();
      }); */
    }
    else {
      this.commonService.ValidationBanner("Please select Network Location");
    }
  }

  CollectItem(event,item) {
    // debugger
    // if(event.checked)
    // item.isSelected = true;
    // else 
    // item.isSelected = false;

      if(this.selectedProducts.indexOf(item.Value)>-1)
      {
        this.selectedProducts.splice(this.selectedProducts.indexOf(item.Value),1);
      }
      else{
        this.selectedProducts.push(item.Value);
      }

//     if (item.isSelected) {
//       this.selectedProducts.push(item.Value);
     
//     }
//     else {
//       this.selectedProducts.splice(this.selectedProducts.indexOf(item.Value),1);
// if(this.selectedProductsNet.findIndex(x=> x == item.Value) != -1)
//       this.selectedProductsNet.splice(this.selectedProductsNet.indexOf(item.Value),1);

//     }
  }
  getNetworkLocations()
  {
    this.summaryService.getRecord('api/ProductNetworkLocations/GetNetworkLocations').subscribe(summary => {
      this.AvailableProducts = summary as [];
    //  if (this.Content.content.flag == "E" || this.Content.content.flag == "N"){this.getSavedappings();}
    this.checkSelected();
    });
  }
 
}
